import ar from "./ar.json";
import en from "./en.json";

export const getCountriesList = (isRTL: boolean) => {
  const localeData = isRTL ? ar : en; // Choose language based on RTL
  return (
    Object.entries(localeData.nationalities).map(([code, name]) => ({
      code, // Country Code (AF, AL, DZ, etc.)
      name // Country Name in Arabic or English
    })) ?? []
  );
};
